// extracted by mini-css-extract-plugin
module.exports = {"chooseTrainer":"main_chooseTrainer__1m4Ef"};